
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rental-businesses",
      function () {
        return require("private-next-pages/rental-businesses.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rental-businesses"])
      });
    }
  